import { useAuthStore } from "@/state/pinia";

export default async (to, from, next) => {
    const authStore = useAuthStore(); //useAuthStore is a Pinia store, so we can use it directly.

    //for Server Side Validate.
    if(process.env.VUE_APP_API_VALIDATE_TOKEN == 'serverSide')
    {
        // console.log('server side auth')

        const status = await authStore.validate();

        if(status != 200)
        {
            next({ name: 'login' })
            return false
        }
        else
        {
            return true
        }
    }
    //for Client Side Validate.
    else if(process.env.VUE_APP_API_VALIDATE_TOKEN == 'clientSide')
    {
        // console.log('client side auth')

        if(!authStore.loggedIn)
        {
            next({ name: 'login' })
            return false
        }
        else
        {
            return true
        }
    }
    else
    {
        next({ name: 'Error-500' })
        return false
    }
}